import { Inmate } from '@reliance/types/models/Inmate';
import React from 'react';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { formatFullName } from '../format/FullName';
import { formatPhoneNumber } from '../format/PhoneNumber';

type InmateDetailBlockProps = {
  inmate: Inmate | null;
  inmateDevice?: unknown;
};

const InmateDetailBlock: React.FC<InmateDetailBlockProps> = (props) => {
  const { inmate } = props;

  return (
    <>
      {inmate &&
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`inmate-preview-${inmate.id}`}>Account: {inmate.account}</Tooltip>}>
          <Link to={`/inmates/view/${inmate.id}`}>{formatFullName(inmate)}</Link>
        </OverlayTrigger>
      }

      {inmate?.phoneNumber &&
        <div>Tel: {formatPhoneNumber(inmate.phoneNumber)}</div>
      }
    </>
  );
}

export default InmateDetailBlock;
